import { Action } from 'redux';

import { NavigateToBackgroundJobTaskDetails } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';

export interface NavigateToBackgroundJobTaskDetailsAction extends Action {
  backgroundJob: IBackgroundJobInfo;
}

export function navigateToBackgroundJobTaskDetailsAction(backgroundJob: IBackgroundJobInfo): NavigateToBackgroundJobTaskDetailsAction {
  return {
    type: NavigateToBackgroundJobTaskDetails,
    backgroundJob,
  };
}

export const isNavigateToBackgroundJobTaskDetailsAction = isActionFactory<NavigateToBackgroundJobTaskDetailsAction>(NavigateToBackgroundJobTaskDetails);
